/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/actions";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../_metronic/layout";
import { CONTEXT } from "../../helpers/ModuleHelpers";
import { AESVG } from "../../../../../_emywork/components/svg";
import { AEShareButtons } from "../../../../../_emywork/components/AEShareButtons";
import { AEReport } from "../../../../../_emywork/components/AEReport";
import { useIntl } from "react-intl";
import { actionTypes } from "../../_redux/slice";
import { AEMetadata } from "../../../../../_emywork/AEPagination";
import { localField } from "../../../../../_emywork/helpers/UIHelper";
import { useFormik } from "formik";
import {
  HTTP_CREATED,
  HTTP_NOT_FOUND,
  HTTP_PERMISSION_DENIED,
} from "../../../../../_emywork/helpers/AxiosHelpers";
import * as ReviewActions from "../../_redux/Reviews/actions";
import { ROUTE_PREFIX, ROUTES } from "../../helpers/RoutingHelpers";
import { AESpinner } from "../../../../../_emywork/spinner/AESpinner";
import { EntityCard } from "../../componants/EntityCard";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Profile } from "./Profile";
import { EmyServices } from "./EmyServices";
import { AEEmail, AEPhone } from "../../../../../_emywork/components/AELink";
import { EmyProjects } from "./EmyProjects";
import { EmyProducts } from "./EmyProducts";
import { ModuleProvider as ChatModuleProvider } from "../../../Chat/ModuleContext";
import PurchasableContact from "../../../../../_emywork/components/contact/PurchasableContact";

export function Details({
  history,
  match: {
    params: { slug },
  },
}) {
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const { authUser } = useSelector(
    ({ auth }) => ({ authUser: auth.user }),
    shallowEqual
  );

  const { isLoading, entity } = useSelector((state) => {
    const s = state[CONTEXT][actionTypes.Details];
    return {
      isLoading: s.isLoading,
      entity: s.entity,
    };
  }, shallowEqual);
  const reviewFormik = useFormik({
    initialValues: {
      // user_id: entity.id, todo
      user_id: authUser.id,
      message: "",
      rating: 0,
    },
    onSubmit: (values) => {
      dispatch(ReviewActions.createEntity(values)).then((r) => {
        if (r.status === HTTP_CREATED) {
          getEntity();
        }
      });
    },
  });
  const { handleSubmit, getFieldProps } = reviewFormik;

  const [currentRoute, setCurrentRoute] = useState();
  const getEntity = () => {
    dispatch(
      actions.fetchEntity(
        slug,
        new AEMetadata(
          {},
          {},
          {},
          [
            "id",
            "username",
            "email",
            "badge",
            "about",
            "legal_form_id",
            "is_saved",
            "rating",
            "rates",
            "file_name",
            "phone",
            "commercial_name",
            "created_at",
            "is_active",
            "is_private",

            "legal_form",
            "activity_area",
            "location",
            "location.country",
            "function_",

            "feedbacks",
            "feedbacks.*.created_by",
            "skills",
            "experiences",
            "educations",
            "awards",
            "emy_projects",
            "emy_services",
            "emy_services.*.is_saved",
            "emy_services.*.rating",
            "emy_services.*.reviews_count",
            "emy_services.*.created_by",
            "emy_services.*.skills",
            "emy_services.*.subcategories",
            "emy_products",
          ],
          "slug"
        ),
        actionTypes.Details
      )
    ).then(({ status }) => {
      if ([HTTP_PERMISSION_DENIED, HTTP_NOT_FOUND].includes(status)) {
        history.push(`/error/${status}`);
      }
    });
  };
  useEffect(() => {
    getEntity();
    setCurrentRoute(ROUTES.details.path.replace(":slug", slug));
  }, [slug, dispatch]);

  useEffect(() => {
    subheader.setTitle(`${entity.name} details`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity, slug]);

  useEffect(() => {
    if (entity.id) {
      reviewFormik.setFieldValue("user_id", entity.id);
    }
  }, [entity.id]);

  const _route = `${ROUTE_PREFIX}/${slug}`;
  const _address = [];
  if (entity.address) _address.push(entity);
  if (entity.location) {
    _address.push(entity.location[localField()]);
    if (entity.location.country) {
      _address.push(entity.location.country[localField()]);
    }
  }

  // console.log(`${_route}/profile`, pathname)

  return (
    <>
      {isLoading ? (
        <Card>
          <CardBody className="text-center">
            <AESpinner />
          </CardBody>
        </Card>
      ) : (
        entity.id && (
          <>
            <ChatModuleProvider>
              <EntityCard
                entity={entity}
                size={"lg"}
                onUpdate={() => {
                  dispatch(
                    actions.toggleSave(
                      entity.id,
                      !entity.is_saved,
                      actionTypes.Details
                    )
                  );
                }}
              />
            </ChatModuleProvider>

            <div className="row">
              <div className="col-lg-8">
                <Switch>
                  <Redirect
                    exact={true}
                    from={_route}
                    to={`${_route}/profile`}
                  />
                  <Route
                    path={`${_route}/profile`}
                    component={() => (
                      <Profile entity={entity} getEntity={getEntity} />
                    )}
                  />
                  <Route
                    path={`${_route}/emy-projects`}
                    component={() => <EmyProjects user_id={entity.id} />}
                  />
                  <Route
                    path={`${_route}/emy-services`}
                    component={() => <EmyServices user_id={entity.id} />}
                  />
                  <Route
                    path={`${_route}/emy-products`}
                    component={() => <EmyProducts user_id={entity.id} />}
                  />
                </Switch>
              </div>
              <div className={"col-lg-4"}>
                <PurchasableContact
                  entity={entity}
                  _address={_address}
                  getEntity={getEntity}
                />

                {/*<div className="card card-custom bgi-no-repeat card-stretch gutter-b h-auto">*/}
                {/*  <div className="card-body my-4">*/}
                {/*    <AEQRCode pathname={currentRoute} />*/}
                {/*  </div>*/}
                {/*</div>*/}

                <div className="card card-custom gutter-b card-stretch h-auto">
                  <div className="card-body text-center pt-4">
                    <div className="h3 my-2 font-weight-bold">
                      {formatMessage({ id: "SHARE" })}
                    </div>
                    <AEShareButtons
                      pathname={currentRoute}
                      facebook
                      twitter
                      linkedin
                    />
                  </div>
                </div>
                <AEReport />
              </div>
            </div>
          </>
        )
      )}
    </>
  );
}
